import React from 'react';
import { useTranslation } from 'react-i18next';
import { MigrationResult } from '../../../../api/General/blobMigration';
import AppIcon from '../../../../components/AppIcon';

interface MigrationResultsProps {
  result: MigrationResult;
}

export default function MigrationResults({ result }: MigrationResultsProps) {
  const { t } = useTranslation();

  const hasFailures = result.failed > 0;

  return (
    <div className="rounded-lg border border-border bg-card">
      <div className="border-b border-border px-6 py-4">
        <h3 className="text-lg font-semibold text-foreground">{t('Migration Results')}</h3>
      </div>
      <div className="p-6 flex flex-col gap-4">
        {/* Alert banner */}
        <div
          className={`flex items-center gap-2 rounded-md px-4 py-3 text-sm ${
            hasFailures
              ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200'
              : 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-200'
          }`}
        >
          <AppIcon name={hasFailures ? 'AlertTriangle' : 'CheckCircle2'} size={18} />
          <span>
            {t('Migration completed')}: {result.migrated} {t('migrated')}, {result.failed}{' '}
            {t('failed')}, {result.skipped} {t('skipped')}
          </span>
        </div>

        {/* Failed files list */}
        {result.failedFiles && result.failedFiles.length > 0 && (
          <div>
            <p className="mb-2 text-sm font-medium text-foreground">{t('Failed Files')}:</p>
            <div className="max-h-[200px] overflow-auto rounded-md border border-border">
              <ul className="divide-y divide-border">
                {result.failedFiles.map((file, index) => (
                  <li key={index} className="px-4 py-2 text-sm text-destructive">
                    {file}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
